import {useRegistrationWizardExperiment} from "./use_registration_wizard_experiment";

/** Read-only check for rendering - it never reports an exposure; the flow and the views where both variants differ report it */
export const useIsRegistrationWizardTreatment = (): boolean => {
    const {isResolved, isTreatment} = useRegistrationWizardExperiment({isEnabled: false});

    return isResolved && isTreatment;
};
import {useRegistrationWizardExperiment} from "./use_registration_wizard_experiment";

/** Read-only check for rendering - it never reports an exposure; the flow and the views where both variants differ report it */
export const useIsRegistrationWizardTreatment = (): boolean => {
    const {isResolved, isTreatment} = useRegistrationWizardExperiment({isEnabled: false});

    return isResolved && isTreatment;
};
